(function () {
  var root = document.querySelector('[data-configurator]');
  if (!root) return;

  var data = JSON.parse(document.getElementById('cfg-data').textContent);
  var text = data.text;
  var form = root.querySelector('form');
  var priceEls = document.querySelectorAll('[data-cfg-price]');
  var summaryEl = root.querySelector('[data-cfg-summary]');
  var liveEl = root.querySelector('[data-cfg-live]');
  var submitBtns = document.querySelectorAll('[data-cfg-submit]');
  var membersWrap = root.querySelector('[data-members]');
  var countEl = root.querySelector('[data-member-count]');
  var mainImg = root.querySelector('[data-main-img]');
  var chipsEl = root.querySelector('[data-chips]');
  var familyInput = root.querySelector('[data-family]');
  var dateInput = root.querySelector('[data-date]');
  var idInput = form.querySelector('[name="id"]');
  var nameRegex = /^[\p{L}][\p{L}\s.'’\-]*$/u;
  var touched = false;
  var swapToken = 0;

  function money(cents) {
    var whole = String(Math.round(cents / 100));
    return whole.replace(/\B(?=(\d{3})+(?!\d))/g, '\u00a0') + '\u00a0Ft';
  }

  function checkedValue(name) {
    var el = root.querySelector('input[name="' + name + '"]:checked');
    return el ? el.value : '';
  }

  function checkedLabel(name) {
    var el = root.querySelector('input[name="' + name + '"]:checked');
    return el ? el.getAttribute('data-label') || el.value : '';
  }

  function isLed() {
    return checkedValue('option_kind') === data.ledLabel;
  }

  function variantFor(size, kind) {
    for (var i = 0; i < data.variants.length; i += 1) {
      var v = data.variants[i];
      if (v.size === size && v.kind === kind) return v;
    }
    return null;
  }

  function currentVariant() {
    return variantFor(checkedValue('option_size'), checkedValue('option_kind'));
  }

  function maxNames(variant) {
    return variant && data.maxNames[variant.size] ? data.maxNames[variant.size] : 8;
  }

  function includedNames(variant) {
    return variant && data.includedNames[variant.size] ? data.includedNames[variant.size] : 8;
  }

  function memberValues() {
    var out = [];
    membersWrap.querySelectorAll('input').forEach(function (input) {
      var value = input.value.trim();
      if (value) out.push(value);
    });
    return out;
  }

  function extraCount(variant) {
    var extra = memberValues().length - includedNames(variant);
    return data.extraVariantId && extra > 0 ? extra : 0;
  }

  function esc(value) {
    return String(value).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; });
  }

  function setError(key, message) {
    var el = root.querySelector('[data-error="' + key + '"]');
    if (!el) return;
    el.textContent = message || '';
    el.hidden = !message;
    var input = key === 'members' ? membersWrap.querySelector('input') : root.querySelector('[data-' + key + ']');
    if (input) input.setAttribute('aria-invalid', message ? 'true' : 'false');
  }

  function validate(showErrors) {
    var variant = currentVariant();
    var family = familyInput.value.trim();
    var members = memberValues();
    var problems = {};

    if (!family || family.length > 24) problems.family = text.errorFamily;
    else if (!nameRegex.test(family)) problems.family = text.errorChars;

    if (!members.length) problems.members = text.errorNoMember;
    else if (members.some(function (n) { return n.length > 18; })) problems.members = text.errorMemberLong;
    else if (members.some(function (n) { return !nameRegex.test(n); })) problems.members = text.errorChars;
    else if (members.length > maxNames(variant)) problems.members = text.errorTooMany.replace('%max%', maxNames(variant));

    if (showErrors) {
      ['family', 'members'].forEach(function (key) { setError(key, problems[key] || ''); });
    }
    return { ok: !Object.keys(problems).length && !!variant && variant.available, problems: problems };
  }

  function addMember(value) {
    var variant = currentVariant();
    if (membersWrap.children.length >= maxNames(variant)) return null;
    var row = document.createElement('div');
    row.className = 'member-row';
    var input = document.createElement('input');
    input.type = 'text';
    input.className = 'field';
    input.maxLength = 18;
    input.autocomplete = 'off';
    input.placeholder = text.memberPlaceholder + ' ' + (membersWrap.children.length + 1);
    input.setAttribute('aria-label', text.memberLabel + ' ' + (membersWrap.children.length + 1));
    if (value) input.value = value;
    input.addEventListener('input', refresh);
    var remove = document.createElement('button');
    remove.type = 'button';
    remove.className = 'member-remove';
    remove.setAttribute('aria-label', text.removeMember);
    remove.textContent = '×';
    remove.addEventListener('click', function () {
      if (membersWrap.children.length > 1) {
        row.remove();
        renumber();
      } else {
        input.value = '';
      }
      refresh();
    });
    row.appendChild(input);
    row.appendChild(remove);
    membersWrap.appendChild(row);
    refresh();
    return input;
  }

  function renumber() {
    Array.prototype.forEach.call(membersWrap.children, function (row, i) {
      var input = row.querySelector('input');
      input.placeholder = text.memberPlaceholder + ' ' + (i + 1);
      input.setAttribute('aria-label', text.memberLabel + ' ' + (i + 1));
    });
  }

  function imageKey(kindKey) {
    return 'tabla-' + checkedValue('option_style') + '-' + checkedValue('option_finish') + '-' + kindKey + '.png';
  }

  function updateImages() {
    var kindKey = isLed() ? 'led' : 'normal';
    var current = data.images[imageKey(kindKey)];
    if (mainImg && current && mainImg.getAttribute('src') !== current.main) {
      swapToken += 1;
      var token = swapToken;
      mainImg.classList.add('is-swapping');
      var next = new Image();
      next.onload = function () {
        if (token !== swapToken) return;
        mainImg.src = current.main;
        mainImg.alt = current.alt || '';
        mainImg.classList.remove('is-swapping');
      };
      next.onerror = function () { if (token === swapToken) mainImg.classList.remove('is-swapping'); };
      next.src = current.main;
    }
    ['normal', 'led'].forEach(function (k) {
      var thumb = root.querySelector('[data-thumb-' + k + ']');
      var img = data.images[imageKey(k)];
      if (thumb && img) thumb.src = img.thumb;
      var btn = root.querySelector('[data-kind-thumb="' + k + '"]');
      if (btn) btn.setAttribute('aria-pressed', k === kindKey ? 'true' : 'false');
    });
    root.querySelectorAll('[data-style-thumb]').forEach(function (el) {
      var img = data.images['tabla-' + el.getAttribute('data-style-thumb') + '-' + checkedValue('option_finish') + '-normal.png'];
      if (img) el.src = img.thumb;
    });
  }

  function updateDeltas() {
    var size = checkedValue('option_size');
    var base = null;
    data.variants.forEach(function (v) { if (v.size === size && base === null) base = v; });
    root.querySelectorAll('[data-kind-delta]').forEach(function (el) {
      var variant = variantFor(size, el.getAttribute('data-kind-delta'));
      if (!variant || !base) { el.textContent = ''; return; }
      var diff = variant.price - base.price;
      el.textContent = diff > 0 ? '+' + money(diff) : money(variant.price);
    });
  }

  function propsFromForm() {
    var variant = currentVariant();
    var members = memberValues();
    var props = {};
    props[data.labels.family] = familyInput.value.trim();
    props[data.labels.members] = members.join('\n');
    if (dateInput.value.trim()) props[data.labels.date] = dateInput.value.trim();
    props[data.labels.finish] = checkedLabel('option_finish');
    props[data.labels.style] = checkedLabel('option_style');
    props['_' + data.labels.nameCount] = String(members.length);
    return { variant: variant, props: props };
  }

  function updateHidden() {
    var current = propsFromForm();
    form.querySelectorAll('[data-prop]').forEach(function (el) { el.remove(); });
    Object.keys(current.props).forEach(function (key) {
      var input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'properties[' + key + ']';
      input.value = current.props[key];
      input.setAttribute('data-prop', '');
      form.appendChild(input);
    });
    if (current.variant) idInput.value = current.variant.id;
  }

  function refresh() {
    var variant = currentVariant();
    var max = maxNames(variant);
    var addBtn = root.querySelector('[data-member-add]');
    if (addBtn) addBtn.disabled = membersWrap.children.length >= max;
    var count = memberValues().length;
    if (countEl) countEl.textContent = count + ' / ' + max + ' ' + text.nameWord + ' · ' + text.namesIncluded.replace('%count%', includedNames(variant));

    var extra = extraCount(variant);
    var extraTotal = extra * data.extraPrice;
    var total = (variant ? variant.price : 0) + extraTotal;
    priceEls.forEach(function (el) { el.textContent = money(total); });
    var extraEl = root.querySelector('[data-cfg-extra]');
    if (extraEl) {
      extraEl.textContent = extra ? text.extraApplied.replace('%n%', extra).replace('%price%', money(extraTotal)) : text.extraName.replace('%price%', money(data.extraPrice));
      if (!data.extraVariantId) extraEl.hidden = true;
    }

    var rows = [
      [text.sumStyle, checkedLabel('option_style') + ', ' + checkedLabel('option_finish').toLowerCase()],
      [text.sumSize, (variant ? variant.size : '–') + ', ' + (variant ? variant.kind : '–')],
      [text.sumFamily, familyInput.value.trim() || '–']
    ];
    if (dateInput.value.trim()) rows.push([text.sumDate, dateInput.value.trim()]);
    rows.push([text.sumMembers, memberValues().join(', ') || '–']);
    summaryEl.innerHTML = '<dl>' + rows.map(function (r) { return '<dt>' + esc(r[0]) + '</dt><dd>' + esc(r[1]) + '</dd>'; }).join('') + '</dl>';
    if (chipsEl) chipsEl.textContent = checkedLabel('option_style') + ' · ' + checkedLabel('option_finish') + ' · ' + (variant ? variant.size + ' · ' + variant.kind : '');

    var avail = variant && variant.available;
    if (nextBtn) { nextBtn.disabled = !avail; }
    submitBtns.forEach(function (btn) {
      btn.disabled = !avail;
      if (!avail) btn.textContent = text.soldOut;
      else if (!btn.classList.contains('is-busy')) btn.textContent = text.addToCart;
    });

    validate(touched);
    updateHidden();
    updateImages();
    updateDeltas();
  }

  function showCartError(message) {
    liveEl.textContent = message;
    liveEl.classList.add('field-error');
  }

  function submit() {
    touched = true;
    var result = validate(true);
    if (!result.ok) {
      var firstKey = ['family', 'members'].filter(function (k) { return result.problems[k]; })[0];
      if (!firstKey) { showCartError(text.soldOut); return; }
      goTo(3);
      var target = firstKey === 'members' ? membersWrap.querySelector('input') : root.querySelector('[data-' + firstKey + ']');
      if (target) target.focus({ preventScroll: true });
      return;
    }
    var current = propsFromForm();
    var items = [{ id: current.variant.id, quantity: 1, properties: current.props }];
    var extra = extraCount(current.variant);
    if (extra) {
      var link = {};
      link['_' + data.labels.linkedTo] = current.props[data.labels.family];
      items.push({ id: data.extraVariantId, quantity: extra, properties: link });
    }
    submitBtns.forEach(function (btn) { btn.classList.add('is-busy'); btn.disabled = true; btn.textContent = text.adding; });
    liveEl.textContent = '';
    liveEl.classList.remove('field-error');
    fetch(data.cartAddUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (response) {
      if (!response.ok) throw new Error('add failed');
      window.location.href = data.cartUrl;
    }).catch(function () {
      submitBtns.forEach(function (btn) { btn.classList.remove('is-busy'); btn.disabled = false; btn.textContent = text.addToCart; });
      showCartError(text.errorGeneric);
    });
  }

  root.querySelectorAll('input[type=radio]').forEach(function (input) {
    input.addEventListener('change', function () {
      if (input.name === 'option_size') {
        var max = maxNames(currentVariant());
        while (membersWrap.children.length > max) membersWrap.lastElementChild.remove();
      }
      refresh();
    });
  });
  [familyInput, dateInput].forEach(function (el) {
    el.addEventListener('input', refresh);
    el.addEventListener('blur', function () { touched = true; refresh(); });
  });
  var addButton = root.querySelector('[data-member-add]');
  if (addButton) addButton.addEventListener('click', function () { var input = addMember(''); if (input) input.focus(); });
  form.addEventListener('submit', function (event) {
    event.preventDefault();
    if (current < steps.length) next(); else submit();
  });

  root.querySelectorAll('[data-kind-thumb]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var wantLed = btn.getAttribute('data-kind-thumb') === 'led';
      root.querySelectorAll('input[name="option_kind"]').forEach(function (r) {
        if ((r.value === data.ledLabel) === wantLed) {
          r.checked = true;
          r.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    });
  });

  var sampleButton = root.querySelector('[data-sample-fill]');
  if (sampleButton) {
    sampleButton.addEventListener('click', function () {
      membersWrap.innerHTML = '';
      data.sampleNames.forEach(function (n) { addMember(n); });
      if (!familyInput.value.trim()) familyInput.value = data.sampleFamily;
      refresh();
    });
  }


  // Lépésenkénti (onboarding-szerű) vezetés
  var steps = Array.prototype.slice.call(root.querySelectorAll('[data-step]'));
  var barItems = root.querySelectorAll('[data-bar-step]');
  var countEl2 = root.querySelector('[data-step-count]');
  var backBtn = root.querySelector('[data-step-back]');
  var nextBtn = root.querySelector('[data-step-next]');
  var cardEl = root.querySelector('.wizard');
  var current = 1;

  function goTo(n, focus) {
    n = Math.max(1, Math.min(steps.length, n));
    var changed = n !== current;
    current = n;
    steps.forEach(function (el, i) {
      var on = i + 1 === n;
      el.hidden = !on;
      if (on && changed) { el.classList.remove('is-entering'); void el.offsetWidth; el.classList.add('is-entering'); }
    });
    barItems.forEach(function (li, i) {
      li.classList.toggle('is-done', i + 1 < n);
      li.classList.toggle('is-current', i + 1 === n);
      if (i + 1 === n) li.setAttribute('aria-current', 'step'); else li.removeAttribute('aria-current');
    });
    if (countEl2) countEl2.textContent = text.stepOf.replace('%n%', n).replace('%t%', steps.length);
    backBtn.hidden = n === 1;
    nextBtn.hidden = n === steps.length;
    submitBtns.forEach(function (b) { b.hidden = n !== steps.length; });
    if (changed && focus !== false) {
      var h = steps[n - 1].querySelector('h3');
      if (h) h.focus({ preventScroll: true });
      var r = cardEl.getBoundingClientRect();
      if (r.top < 70 || r.top > window.innerHeight * 0.5) {
        var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        cardEl.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
      }
    }
  }

  function stepProblems(n) {
    if (n === 2) {
      var v = currentVariant();
      return v && v.available ? null : text.soldOut;
    }
    if (n === 3) {
      touched = true;
      var res = validate(true);
      var key = ['family', 'members'].filter(function (k) { return res.problems[k]; })[0];
      return key || null;
    }
    return null;
  }

  function next() {
    var problem = stepProblems(current);
    if (problem) {
      if (current === 2) { liveEl.textContent = problem; liveEl.classList.add('field-error'); return; }
      var target = problem === 'members' ? membersWrap.querySelector('input') : root.querySelector('[data-' + problem + ']');
      if (target) target.focus({ preventScroll: false });
      return;
    }
    goTo(current + 1);
  }

  nextBtn.addEventListener('click', next);
  backBtn.addEventListener('click', function () { goTo(current - 1); });
  root.querySelectorAll('[data-bar-step]').forEach(function (li, i) {
    li.addEventListener('click', function () { if (i + 1 < current) goTo(i + 1); });
  });

  addMember('');
  addMember('');
  addMember('');
  refresh();
  goTo(1, false);
})();
